import { InvoiceStatus } from '../@types';

export const REPEAT_EVERY_WEEK = 'Weekly';
export const REPEAT_EVERY_2_WEEKS = '2 weeks';
export const REPEAT_EVERY_MONTH = 'Month';
export const REPEAT_EVERY_2_MONTHS = '2 months';
export const REPEAT_EVERY_3_MONTHS = '3 months';
export const REPEAT_EVERY_6_MONTHS = '6 months';
export const REPEAT_EVERY_YEAR = 'Year';
export const REPEAT_EVERY_2_YEARS = '2 year';
export const REPEAT_EVERY_3_YEARS = '3 year';

export const REOCCURRING_FREQUENCY = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' },
];

export const Statuses: {
  IN_STOCK: string;
  OUT_STOCK: string;
  HAS_VARIATION: string;
  HAS_NO_VARIATION: string;
} = {
  IN_STOCK: 'in-stock',
  OUT_STOCK: 'out-of-stock',
  HAS_VARIATION: 'has-variation',
  HAS_NO_VARIATION: 'has-no-variation',
};

export const STATUS_TEXT = {
  HAS_VARIATION: 'has-variation',
  HAS_NO_VARIATION: 'has-no-variation',
  IN_STOCK: 'in-stock',
  OUT_STOCK: 'out-of-stock',
};
